import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { UserProfileNoIdDto } from 'src/app/shared/models/user/user-profile-dto';
import { UserProfileService } from 'src/app/shared/services/user-profile/user-profile.service';

@Component({
    selector: 'app-create-user-profile',
    templateUrl: './create-user-profile.component.html',
    styleUrl: './create-user-profile.component.scss',
    standalone: false
})
export class CreateUserProfileComponent {
  loading = false;
  form: FormGroup = null;
  values: UserProfileNoIdDto = null;

  constructor(
    private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly userProfileService: UserProfileService
  ) {}

  onFormChange(event: any) {
    this.form = event.form;
    this.values = event.values;
  }

  submitForm() {
    if (this.form.invalid) {
      return this.alertService.showAlert({ type: AlertType.critical, content: 'Preencha todos os campos obrigatórios!' } as Alert);
    }

    this.loading = true;
    this.userProfileService
      .create(this.values)
      .subscribe({
        next: () => {
          this.alertService.showAlert({ type: AlertType.success, content: 'Grupo de Usuário cadastrado com sucesso!' } as Alert);
          this.router.navigate(['/user-profiles']);
        },
        error: () => {
          this.alertService.showAlert({ type: AlertType.critical, content: 'Ocorreu um erro ao cadastrar o Grupo de Usuário!' } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }
}
